import styles from './LoggedOutBanner.less';
import React, { Component } from 'react';

import ProfileBanner from './ProfileBanner/ProfileBanner';

export default class LoggedOutBanner extends Component {
  render() {
    return (
      <div className={styles.root}>
        <div className={styles.container}>
          <ProfileBanner />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/LoggedOutBanner/LoggedOutBanner.js
 **/